export const getAuthCookieDomain = (): string => {
  /* istanbul ignore if */
  if (!process.env.AUTH_COOKIE_DOMAIN) {
    throw new Error('env variable AUTH_COOKIE_DOMAIN must be defined')
  }

  return process.env.AUTH_COOKIE_DOMAIN
}
